var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m13.796 10.755-.38.378s-.902.897-3.365-1.552c-2.462-2.448-1.56-3.345-1.56-3.345l.239-.238c.589-.585.644-1.525.13-2.211L7.81 2.383c-.636-.85-1.865-.962-2.593-.237l-1.308 1.3c-.362.36-.604.826-.575 1.342.076 1.322.674 4.166 4.01 7.485 3.54 3.518 6.86 3.658 8.218 3.532.43-.04.803-.26 1.104-.559l1.184-1.177c.8-.794.574-2.156-.449-2.712l-1.592-.865c-.671-.365-1.489-.258-2.013.263Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone1);
export default __webpack_public_path__ + "static/media/phone 1.894e573aeef95e3c2b355f1831bbb58c.svg";
export { ForwardRef as ReactComponent };